import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const actionsApi = createApi({
  reducerPath: 'actionsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/common/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getActions: builder.query({
      query: () => `actionsList`,
    }),
    createOrUpdateActions: builder.mutation({
      query: (formData) => {
        return {
          url: `createEditActions`,
          method: 'post',
          body: formData
        }
      }
    }),
    deleteActions: builder.mutation({
      query: (guid) => {
        return {
          url: `deleteActions`,
          method: 'DELETE',
          params: { actions_guid: guid },
        }
      }
    })
  }),
})

export const { useGetActionsQuery, useCreateOrUpdateActionsMutation, useDeleteActionsMutation } = actionsApi